import clsx from 'clsx';
import { type ReactNode } from 'react';

import { Modal } from '@flintmint/web-shared/components/modal';
import { Icon } from '@flintmint/web-shared/components/icon';

import styles from './ai-context-modal-frame.module.scss';

export const AiContextModalFrame = (props: AiContextModalFrameProps) => {
  const { open, title, onClose, onClosed, className, children, showFooter = true, onAddMore } = props;

  return (
    <Modal
      freeForm
      open={open}
      onClose={onClose}
      onClosed={onClosed}
      closeOnClickOutside
      data-testid="context-items-modal"
      holderClassName={clsx(styles.contextItemsModalHolder, className)}
    >
      <div className={styles.contextModalHeader}>
        <div>{title}</div>
        <button data-testid="close-modal-button" onClick={onClose}>
          <Icon type="cancel-01" size={24} />
        </button>
      </div>
      {children}
      {showFooter && (
        <div className={styles.contextModalFooter}>
          <button onClick={onAddMore}>
            <Icon type="add-01" size={16} />
            Add more
          </button>
        </div>
      )}
    </Modal>
  );
};

export interface AiContextModalFrameProps {
  open: boolean;
  title?: string;
  className?: string;
  onClose: () => void;
  onClosed?: () => void;
  children?: ReactNode;
  showFooter?: boolean;
  onAddMore?: () => void;
}
